// useDarkMode.js
import { useEffect, useState } from 'react';
import * as Constants from "../../../constants/Constants";

export const useDarkMode = () => {
    const [theme, setTheme] = useState(Constants.defaultTheme);
    const [componentMounted, setComponentMounted] = useState(false);

    const setMode = mode => {
        window.localStorage.setItem('theme', mode)
        setTheme(mode)
    };

    const toggleTheme = () => {
        if (theme === 'light') {
            setMode('dark');
        } else {
            setMode('light');
        }
    };

    useEffect(() => {
        const localTheme = window.localStorage.getItem('theme');
        if (localTheme) {
            setTheme(localTheme);
        } else {
            setMode(Constants.defaultTheme);
        }
        setComponentMounted(true);
    }, []);

    return [theme, toggleTheme, componentMounted]
};